module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-5 darker"
  }, [_c('div', {
    staticClass: "col-md-12 text-right"
  }, [_c('input', {
    staticClass: "btn widest ml-auto",
    attrs: {
      "type": "submit",
      "value": "Save"
    },
    on: {
      "click": _vm.save
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9351cdea"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/TabTicket.vue
// module id = 2224
// module chunks = 0